module.exports = __webpack_public_path__ + "img/DSC_0097.d6af286b.jpg";